import { ApolloProvider } from "@apollo/client"
import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/700.css"
import { CssBaseline, ThemeProvider } from "@mui/material"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider/LocalizationProvider"
import { LicenseInfo } from "@mui/x-license"
import "dayjs/locale/de"
import { StoreProvider } from "easy-peasy"
import { SnackbarProvider } from "notistack"
import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { apolloClient } from "store/apolloClient"
import snackbarConfig from "store/snackbarConfig"
import { store } from "store/store"
import App from "./App"
import { msalConfig } from "./authConfig"
import "./index.css"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"
import { baseTheme } from "./themes/BaseTheme"

LicenseInfo.setLicenseKey(`${process.env.REACT_APP_MUI_X_LICENSE_KEY}`)

export const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={baseTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <StoreProvider store={store}>
            <ApolloProvider client={apolloClient}>
              <SnackbarProvider {...snackbarConfig}>
                <CssBaseline />
                <App />
              </SnackbarProvider>
            </ApolloProvider>
          </StoreProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </MsalProvider>
  </StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
